import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAgitatorCrossBeam = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 120,
	viewBox: "0 0 80.0 120.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 40.0 0.0 L 40.0 120.0 M 0.0 80.0 L 80.0 80.0 M 80.0 120.0 L 0.0 120.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgAgitatorCrossBeam;
